import { Injectable } from '@angular/core';
import { ResponseObject } from '../models/response-object.model';
import { Observable } from 'rxjs';
import { HttpClient } from '@angular/common/http';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class ExtractionsReportService {

  private url = environment.api + 'api/erp/extractions/report';
  
    constructor(private http: HttpClient) {}
  
    getEntryNoteReport(type: string, startDate: any, endDate: any): Observable<ResponseObject> {
      return this.http.get<ResponseObject>(`${this.url}/entry-notes/${type}`, {
        params: {
          startDate: startDate,
          endDate: endDate
        }
      });
    }

    getExitNoteReport(type: string, startDate: any, endDate: any): Observable<ResponseObject> {
      return this.http.get<ResponseObject>(`${this.url}/exit-notes/${type}`, {
        params: {
          startDate: startDate,
          endDate: endDate
        }
      });
    }
}
